/**
 * Formats a meeting date from GMT to user timezone and returns it in a nice format
 * @param {string} dateString - The original date string from the server
 * @returns {string} - Formatted date string
 */
export const formatMeetingDate = (dateString) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Check if we already formatted this date
  if (!dateString.includes("GMT")) {
    return dateString;
  }

  try {
    // Set to the user timezone
    const timeZoneOffset = -new Date().getTimezoneOffset() / 60;
    const time = dateString.split(",")[1];
    const splitted = time.split(" ");
    
    // Adjust hour for timezone
    const currentHour = Number(splitted[4].split(":")[0]);
    const adjustedHour = currentHour + timeZoneOffset;
    const minutes = splitted[4].split(":")[1];
    const seconds = splitted[4].split(":")[2];
    
    let day = Number(splitted[1]);
    let month = splitted[2];
    let year = Number(splitted[3]);
    let hour = adjustedHour;

    // Handle day overflow/underflow
    if (hour < 0) {
      hour += 24;
      day -= 1;
      
      if (day < 1) {
        const monthIndex = months.indexOf(month);
        if (monthIndex > 0) {
          month = months[monthIndex - 1];
          const daysInPrevMonth = new Date(year, monthIndex - 1, 0).getDate();
          day = daysInPrevMonth;
        } else {
          month = months[11];
          day = 31;
          year -= 1;
        }
      }
    } else if (hour >= 24) {
      hour -= 24;
      day += 1;
      
      const monthIndex = months.indexOf(month);
      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      
      if (day > daysInMonth) {
        day = 1;
        if (monthIndex < 11) {
          month = months[monthIndex + 1];
        } else {
          month = months[0];
          year += 1;
        }
      }
    }

    // Format the final time string
    const formattedHour = hour.toString().padStart(2, '0');
    const timeString = `${formattedHour}:${minutes}:${seconds}`;

    // Create the formatted date
    const monthIndex = months.indexOf(month) + 1;
    const formattedMonth = monthIndex.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');
    const shortYear = year.toString().substring(2);

    return `${formattedDay}/${formattedMonth}/${shortYear} ${timeString.substring(0, 5)}`;
    
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString; // Return original if formatting fails
  }
};

/**
 * Checks if a date string needs formatting
 * @param {string} dateString - The date string to check
 * @returns {boolean} - True if the date needs formatting
 */
export const needsDateFormatting = (dateString) => {
  return dateString && dateString.includes("GMT");
}; 